// components/Menu/parts/SearchBlock.jsx
import SearchField from "./SearchField";
import { useMenu } from "../context/MenuContext";

const SearchBlock =
  (/*{ onSearchAdresse, onSearchMaison, searchAdresse, searchMaison }*/) => {
    const { onSearchAdresse, onSearchMaison, searchAdresse, searchMaison } =
      useMenu();
      
    return (
      <div className="menu-search">
        <SearchField
          label="domonyme"
          value={searchMaison}
          onChange={onSearchMaison}
          onSearch={onSearchMaison}
        />
        <SearchField
          label="rue" // "voie" // odonyme
          value={searchAdresse}
          onChange={onSearchAdresse}
          onSearch={onSearchAdresse}
        />
      </div>
    );
  };

export default SearchBlock;
